import React from 'react';
export function AudienceSection() {
  const steps = [{
    num: '01',
    title: 'Identificación',
    desc: 'Detecta el patrón oculto en tu árbol familiar.'
  }, {
    num: '02',
    title: 'Corte',
    desc: 'Ejecuta el protocolo de autoridad espiritual para soltar la carga.'
  }, {
    num: '03',
    title: 'Reclamo',
    desc: 'Activa la bendición y el propósito que Dios diseñó para ti.'
  }];
  return <section className="pt-10 pb-8 px-4 bg-cream-light border-y border-gold/20" data-id="element-9">
      <div className="max-w-5xl mx-auto" data-id="element-10">
        {/* How it works */}
        <div className="mb-24" data-id="element-11">
          <h2 className="text-3xl md:text-4xl font-serif text-charcoal font-bold mb-12 text-center" data-id="element-12">
            Cómo funciona el proceso
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-13">
            <div className="hidden md:block absolute top-8 left-1/6 right-1/6 h-px bg-gold/30 z-0" data-id="element-14"></div>

            {steps.map((step, i) => <div key={i} className="relative z-10 flex flex-col items-center text-center" data-id="element-15">
                <div className="w-16 h-16 rounded-full bg-gold text-white font-serif text-2xl flex items-center justify-center mb-6 shadow-md" data-id="element-16">
                  {step.num}
                </div>
                <h4 className="text-xl font-serif font-bold text-charcoal mb-3" data-id="element-17">
                  {step.title}
                </h4>
                <p className="text-charcoal-light" data-id="element-18">{step.desc}</p>
              </div>)}
          </div>
        </div>

        {/* Proof / Believability */}
        <div className="bg-charcoal text-cream p-8 md:p-12 text-center relative overflow-hidden" data-id="element-19">
          <div className="absolute top-0 left-0 w-full h-1 bg-gold" data-id="element-20"></div>
          <h2 className="text-2xl md:text-3xl font-serif font-bold mb-6 text-gold-light" data-id="element-21">
            Lo que cambia en 7 días
          </h2>
          <p className="text-lg md:text-xl font-serif italic mb-6 text-cream-dark" data-id="element-22">
            "No es magia, es orden."
          </p>
          <p className="text-cream-dark/90 max-w-2xl mx-auto leading-relaxed" data-id="element-23">
            Cuando dejas de cargar lo que no es tuyo, tu energía se libera.
            Verás cómo las oportunidades que antes "rebotaban" empiezan a
            entrar, y cómo esa presión constante en el pecho desaparece, dando
            lugar a una paz que sobrepasa todo entendimiento.
          </p>
        </div>
      </div>
    </section>;
}